import React from 'react';
import { Box, Button, Link as MatLink, styled, useTheme } from '@mui/material';
import { HeaderContentWrapper } from './HeaderContentWrapper';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { B2B_URL } from '../../../utils/constans/constans';
import { LogoWrapperB2B } from '../../shared/logos/LogoWrapperB2B';
import useUserSWR from '../../../hooks/user/useUserSWR';
import { CartMenuItem } from '../../shared/CartMenuItem/CartMenuItem';
import { SearchInput } from './SearchInput/SearchInput';

const SearchBox = styled(Box)(({ theme }) => ({
    width: '100%',
    // '@media (max-width: 1600px)': {
    //     width: '90%',
    // },
    // '@media (max-width: 1200px)': {
    //     width: '75%',
    // },
    // '@media (max-width: 1000px)': {
    //     width: '70%',
    // },
}));

const ActionBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifySelf: 'end',
    alignItems: 'center',
    gap: '5px',
    paddingLeft: '10px',
    flexWrap: 'wrap-reverse',
    justifyContent: 'flex-end',
}));

const ActionItems = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifySelf: 'end',
    alignItems: 'center',
    gap: '5px',
    paddingLeft: '10px',
}));

const StyledButton = styled(Button)(({ theme }) => ({
    margin: '0 2px 0 0',
    fontSize: '0.875rem',
    '@media (max-width: 1440px)': {
        margin: '0 -2px 0 -2px',
        fontSize: '0.785rem',
    },
}));

const StyledQuotationButton = styled(Button)(({ theme }) => ({
    margin: '0 2px 0 0',
    fontSize: '0.875rem',
    color: '#FFF',
    border: '1px solid #007CB0',
    width: '135px',
    height: '22px',
    background: '#007CB0',
    whiteSpace: 'nowrap',
    ':hover': {
        background: '#007CB0',
        color: '#FFF',
    },
    '@media (max-width: 1440px)': {
        margin: '0 3px 0 3px',
        fontSize: '0.785rem',
        width: '116px',
        height: '21px',
    },
}));

const StyledBackToShopButton = styled(Button)(({ theme }) => ({
    margin: '0 2px 0 0',
    fontSize: '0.875rem',
    color: '#007cb0',
    border: '1px solid #007CB0',
    height: '22px',
    background: '#f4f4f4',
    whiteSpace: 'nowrap',
    ':hover': {
        background: '#007CB0',
        color: '#FFF',
    },
    '@media (max-width: 1440px)': {
        margin: '0 3px 0 3px',
        fontSize: '0.785rem',
        height: '21px',
    },
}));

export const Header: React.FC<{ displaySearch?: boolean }> = (props) => {
    const { displaySearch } = props;
    const { user } = useUserSWR();
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <>
            <HeaderContentWrapper columnNumner={displaySearch ? 3 : 2}>
                <LogoWrapperB2B />
                {displaySearch && (
                    <SearchBox>
                        {' '}
                        <SearchInput />
                    </SearchBox>
                )}
                <ActionBox>
                    <ActionItems>
                        <MatLink href={B2B_URL} underline="none">
                            <StyledBackToShopButton>
                                {t('HEADER.SHOP')}
                            </StyledBackToShopButton>
                        </MatLink>
                        <Link to={'/quotations'}>
                            <StyledQuotationButton>
                                {t('HEADER.QUOTATION')}
                            </StyledQuotationButton>
                        </Link>
                    </ActionItems>
                    <ActionItems>
                        <Link to={'/profile'}>
                            <StyledButton>Profil</StyledButton>
                        </Link>
                        {user && user.is_admin && (
                            <>
                                <Link to={'/admin/users'}>
                                    <StyledButton>Admin</StyledButton>
                                </Link>
                            </>
                        )}
                        <CartMenuItem />
                    </ActionItems>
                </ActionBox>
            </HeaderContentWrapper>
        </>
    );
};
